export default {
  navigationBarTitleText: 'axios'
};
